(()=>{
 // Keep the last footer links above Shopify's optional draft-preview toolbar.
 let previewBar;
 function measurePreview(){
  const candidate=document.getElementById('PBarNextFrameWrapper');
  if(candidate&&candidate!==previewBar){previewBar=candidate;new ResizeObserver(measurePreview).observe(candidate);new MutationObserver(measurePreview).observe(candidate,{attributes:true,attributeFilter:['class','style']});}
  const rect=previewBar?.getBoundingClientRect(),clearance=rect?.height?Math.max(0,innerHeight-rect.top):0;
  const value=clearance+'px';if(document.documentElement.style.getPropertyValue('--ghm-preview-clearance')!==value)document.documentElement.style.setProperty('--ghm-preview-clearance',value);
 }
 const discovery=new MutationObserver(()=>{measurePreview();if(previewBar)discovery.disconnect();});
 discovery.observe(document.body,{childList:true,subtree:true});addEventListener('resize',measurePreview);measurePreview();

 const section=document.querySelector('[data-ownership-modules]'),rail=section?.querySelector('.ownership-modules-rail');
 if(!rail)return;
 function sync(){
  const compact=rail.offsetWidth>0&&getComputedStyle(rail).display==='grid';
  if(compact){rail.removeAttribute('tabindex');rail.setAttribute('aria-label','Deposit, delivery, service and free class');}
  else{rail.tabIndex=0;rail.setAttribute('aria-label','Deposit, delivery, service and free class. Use left and right arrow keys to scroll.');}
 }
 new ResizeObserver(sync).observe(rail);sync();
})();
